import React, { useState, useEffect } from "react";
import { useAPI } from "../lib/common";

// Our hook
export default function useMyOrdersList() {
  const [orderList, loading, error] = useAPI("/ajax/user/get_order_list.php");

  return [orderList, loading, error];
}
